<template>
  <li class="w-max">
    <div class="flex justify-between items-center" :class="{ active }" @click="active = !active">
      <span v-if="chapter.title" class="text--md uppercase">{{ $t(chapter.title) }}</span>
      <i-material-symbols-arrow-forward-ios-rounded class="text-primary rotate-90 md:hidden" :class="{ 'rotate-[270deg]': active }" />
    </div>
    <ul class="hidden flex-col gap-2 md:flex md:gap-4" :class="{ 'nav-active': active }">
      <FooterNavItem v-for="link in chapter.links" :key="link.title" :link="link" />
    </ul>
  </li>
</template>

<script setup>
import { ref } from "vue"
import FooterNavItem from "./FooterNavItem.vue"
defineProps({
  chapter: {
    type: Object,
    required: true,
  },
})

const active = ref(false)
</script>

<style lang="scss" scoped>
.nav-active {
  display: flex !important;
}
</style>
